import http from '../config/http';

const basicUrl = '/api/v1/social-link';

const getAll = () => {
    return http.get(basicUrl);
};

export const socialService = {
    getAll,
};
